// extracted by mini-css-extract-plugin
export default {"overlay":"ModalOverlay_overlay__Zg7jO"};